import { forwardRef, ForwardRefRenderFunction, ImgHTMLAttributes } from 'react';
import { ImageSources } from '../../types';
import { createSrcSet } from '../../lib/create-src-set';

type Props = { sources: ImageSources } & Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'srcSet'
>;

const Entry: ForwardRefRenderFunction<HTMLImageElement, Props> = (
  { sources, alt, loading = 'lazy', ...props },
  ref
) => {
  const srcSetAttributeValue = createSrcSet(sources);

  return (
    <img
      {...props}
      srcSet={srcSetAttributeValue}
      src={sources.base}
      alt={alt}
      loading={loading}
      ref={ref}
    />
  );
};

export const EntryWithRef = forwardRef(Entry);
